export const getGroupItems = (data, groupId) => {
    const items = [];
    data.images && items.push(...data.images.filter(image => image.group?.id === groupId));
    data.models && items.push(...data.models.filter(model => model.group?.id === groupId));
    return items;
}